import { createSlice } from '@reduxjs/toolkit'
import { fetchIncomeStatementReport } from './thunks/incomeStatement';

const initialState = {
    data: "",
    isLoading: false,
    error: null,
    isNoteActive: false,
    showPercentage: false
}

const incomeStatementReport = createSlice({
    name: 'INCOMESTATEMENTSLICE',
    initialState,
    reducers: {
        addSymbols(state, action){
            state.availableSymbols = action.payload
        },
        setIsNoteActiveState(state, action){
          state.isNoteActive = !state.isNoteActive
        },
        setShowPercentage(state, action) {
          state.showPercentage = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchIncomeStatementReport.pending, (state) => {
          state.isLoading = true
        })
        builder.addCase(fetchIncomeStatementReport.fulfilled, (state, action) => {
          state.isLoading = false
          state.data = action.payload
        })
        builder.addCase(fetchIncomeStatementReport.rejected, (state, action) => {
          state.isLoading = false
          state.error = action.error.message
          state.data = null
        })
    }
});

export const { addSymbols, setIsNoteActiveState, data, setShowPercentage } = incomeStatementReport.actions

export default incomeStatementReport;